import { useLocation, useNavigate } from "react-router-dom";
import Input from "../../components/Inputs/Input";
import AuthLayout from "../../components/layouts/AuthLayout";
import axiosInstance from "../../utils/axiosInstance";
import { useState } from "react";
import { API_PATHS } from "../../utils/apiPaths";

const VerifyOTP = () => {
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error,setError] = useState('')
  const [valid,setValid] =  useState(true)
  const [response, setResponse] = useState('')
  const location = useLocation();
 const navigate = useNavigate();

  const verifyOtp = async () => {
     
    try {
    //   await axiosInstance.post(API_PATHS.AUTH.VERIFY_OTP, { email, otp, newPassword });
       const response = await axiosInstance.post(API_PATHS.AUTH.VERIFY_OTP, {
      email: location.state?.email, // Doit être exactement le même que celui envoyé initialement
      otp: otp.trim(), // Enlevez les espaces accidentels
      newPassword: newPassword.trim()})
      // Redirection après succès
       setResponse(response.data.message)
    } catch (err) {
      // Gestion des erreurs
      setError(err.response?.data?.message || 'TOKEN non valide veillez ressayer');
        if(!otp){
           setValid(false)
       }
    }
  };

  return (
    <AuthLayout>
      <h2 className="mt-10 flex justify-center items-center">Vérification OTP</h2>
      <Input
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="Code OTP (6 chiffres)"
      />

      {valid &&   <Input
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        placeholder="Nouveau mot de passe"
      />}
      {error && <p className="text-red-500 text-xs pb-2.5">{error}</p>}
      {response && <p className="text-green-600">{response}</p>}
       {!response ? (
        <button
          onClick={verifyOtp}
          className="btn-primary disabled:opacity-50"
        >
          Valider
        </button>
      ) : (
        <button
          onClick={() => navigate("/login")}
          className="btn-primary bg-green-600"
        >
          Se connecter
        </button>
      )}
    </AuthLayout>
  );
};


export default  VerifyOTP;